import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Language from '@mui/icons-material/Language';
import { MenuItem as MuiMenuItem } from '@mui/material';
import MuiSelect, { SelectChangeEvent } from '@mui/material/Select';
import { translate, getActiveLang } from '@openclassrooms/translations';
import { styled } from '@classify/react-core-components/styles';
import Box from '@classify/react-core-components/Box';
interface Props {
  onChangeLang?: (newLang: string) => void;
}
const AVAILABLE_LANGS = [{
  label: 'Français',
  value: 'fr'
}, {
  label: 'English',
  value: 'en'
}];
const Root = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'content',
  minHeight: 48
});
const MenuItem = styled(MuiMenuItem)({
  '&$menuItem': {
    boxSizing: 'content-box',
    fontWeight: 'normal'
  }
});
const Select = styled(MuiSelect)(({
  theme: {
    breakpoints
  }
}) => ({
  width: '200px',
  [breakpoints.up('sm')]: {
    width: '100%'
  }
}));
const LangSelector = t0 => {
  const $ = _c(10);
  const {
    onChangeLang
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getActiveLang();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedLang, setSelectedLang] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Language sx={{
      verticalAlign: "middle",
      paddingRight: 1,
      color: "text.onMain"
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      flex: 1
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onChangeLang) {
    t4 = event => {
      const newLang = event.target.value;
      onChangeLang?.(newLang);
      setSelectedLang(newLang);
    };
    $[3] = onChangeLang;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      "aria-label": translate("footer.language.title")
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = AVAILABLE_LANGS.map(_temp);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== selectedLang || $[8] !== t4) {
    t7 = <Root>{t2}<Box sx={t3}><Select id="footerChangeLanguage" onChange={t4} value={selectedLang} inputProps={t5} variant="standard">{t6}</Select></Box></Root>;
    $[7] = selectedLang;
    $[8] = t4;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
export default LangSelector;
function _temp(t0) {
  const {
    label,
    value
  } = t0;
  return <MenuItem key={value} value={value}>{label}</MenuItem>;
}